import { expiryState, formatDateOnly } from '../lib/expiry.ts';

// Small read-only status chip for an uploaded file's expiry date. Colour and
// label are derived from the shared expiryState() helper so the warning window
// (EXPIRY_WARNING_DAYS) stays defined in one place.
//
//   expired   → red    "Expired · 12 May 2026"
//   expiring  → amber  "Expires 8 Jun 2026"
//   ok        → grey   "Expires 30 Dec 2026"
//   none      → nothing (no chip when a file has no / no-longer-required expiry)
export function ExpiryChip({ expiresAt }: { expiresAt: string | null }) {
  const state = expiryState({ expires_at: expiresAt });

  // No expiry set (or not required): render nothing rather than a placeholder
  // "No expiry date" badge.
  if (state === 'none') {
    return null;
  }

  const date = formatDateOnly(expiresAt);

  if (state === 'expired') {
    return (
      <span className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700">
        Expired · {date}
      </span>
    );
  }

  if (state === 'expiring') {
    return (
      <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
        Expires {date}
      </span>
    );
  }

  return (
    <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
      Expires {date}
    </span>
  );
}
